// Config central para SEO: nombre del sitio y dominio de producción.
//
// SITE_URL se usa para construir <link rel="canonical">, og:url y las URLs
// absolutas del sitemap.xml (ver src/scripts/generateCatalogo.js). El dominio
// de producción es cleanzone.mx; REACT_APP_SITE_URL sólo hace falta para
// apuntar a otro entorno (preview de Vercel, staging), y si se usa debe ir
// sin slash final y con el mismo valor en el .env del build, porque el
// sitemap se genera con esa misma variable.
export const SITE_URL = (process.env.REACT_APP_SITE_URL || 'https://cleanzone.mx').replace(/\/$/, '');

export const SITE_NAME = 'CleanZone';

export const DEFAULT_TITLE = 'CleanZone | Distribuidora de productos de limpieza en Culiacán';

export const DEFAULT_DESCRIPTION =
  'Papel institucional, limpiadores, desechables y equipo de limpieza para tu hogar, negocio o empresa. ' +
  'Envío gratis desde $500, crédito para negocios y atención personalizada en Culiacán, Sinaloa.';

export const absoluteUrl = (path = '') => `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;
